<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Edit Table"
        @onSubmit="SaveTable"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Name"
                vid="name"
                rules="required"
                hide-details="auto"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  label="Name"
                  v-model="Table.name"
                  auto-grow
                  outlined
                ></v-text-field>
              </ValidationProvider>
              <v-checkbox
                v-model="Table.is_event"
                :label="`Event`"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="Table.is_event">
            <v-col cols="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Date"
                rules="required"
                hide-details="auto"
              >
                <DatePicker
                  :labelname="'Date'"
                  v-model="Table.event_date"
                  :max="Datemax"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="!Table.is_event">
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Capacity"
                rules="required|min_value:1"
                hide-details="auto"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  label="Capacity"
                  type="number"
                  v-model="Table.capacity"
                  auto-grow
                  outlined
                  min="1"
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Type"
                rules="required"
                hide-details="auto"
              >
                <v-select
                  hide-details="auto"
                  :items="tableTypes"
                  :loading="loading"
                  :error-messages="errors"
                  v-model="Table.type"
                  item-text="name"
                  item-value="id"
                  label="Type"
                  outlined
                  clearable
                  dense
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import DatePicker from "@/components/base/DateComponent.vue";

import { mapState } from "vuex";
import CustomModal from "@/components/base/CustomModal";
import { required, email, max , min_value } from "vee-validate/dist/rules";
import _ from "lodash";
import axios from "@/plugins/axios";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

extend("required", {
  ...required,
  message: "{_field_} is required"
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters"
});

extend("email", {
  ...email,
  message: "Email must be valid"
});

extend("min_value", {
  ...min_value,
  message: "{_field_} must be at least {min}",
});

export default {
  data: () => ({
    dialog: false,
    show: false,
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,
      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16]
    },
    pagination: {
      page: 1,
      itemsPerPage: 2
    },
    page: 1,
    Ingredients: {
      name: ""
    },

    tableTypes: [
      { id: "Circle", name: "Circle" },
      { id: "Square", name: "Square" },
      { id: "Rectangle", name: "Rectangle" },
      { id: "Oval", name: "Oval" }
    ],
    value: [],
    options: [],
    isLoading: false
  }),

  name: "Add Employe",
  props: {
    Table: {
      type: Object,
      default: {}
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomModal,
    DatePicker
  },

  methods: {
    OpenModal() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.Ingredients = {};
      this.$refs.observer.reset();
    },
    async SaveTable() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.EditTable();
      }
    },

    EditTable() {
      this.isLoading = true;
      let credential = this.Table;
      let tableid = this.Table.id;

      if (this.Table.is_event == null) {
        this.Table.is_event = false;
      }

      if (this.Table.is_event == true) {
        credential.capacity = null;
        credential.type = null;
      }

      delete credential.id;
      delete credential.created_at;
      delete credential.is_active;
      axios
        .patch(`hms/tables/${tableid}`, credential)
        .then(async res => {
          this.succeeed = true;

          this.$emit("afterSave");
          this.$toast.success("Table Edited  successfully");
          this.show = false;
          this.isLoading = false;
          this.Table = {
            name: null,
            capacity: 0,
            type: null
          };
          this.$refs.observer.reset();
        })
        .catch(() => {
          this.$refs.observer.setErrors(err.response.data.error);
          this.$toast.error("Table Edited failed");
          this.isDisabledSubmit = false;
          this.isLoading = false;

          // this.Table = {
          //   name: null,
          //   capacity: 0,
          //   type: null
          // };
          this.isLoading = false;

          // this.$refs.observer.reset();
        });
    }
  }
};
</script>
